/**
 * modes/stage-reset.js
 * Reset sân khấu tập trung, dọn dẹp an toàn các đối tượng của chế độ cũ trước khi chuyển sang chế độ mới.
 */

export function resetStage(state, helpers = {}) {
  const { clearAvatars, clearCityScene, clearLabBench } = helpers;

  if (typeof clearCityScene === 'function') {
    clearCityScene(state);
  }
  if (typeof clearAvatars === 'function') {
    clearAvatars(state);
  }
  if (typeof clearLabBench === 'function') {
    clearLabBench(state);
  }
}
